'use client';

import React from 'react';

interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode;
  className?: string;
  hint?: React.ReactNode;
  hintClassName?: string;
  hintId?: string;
  hintHidden?: boolean;
  type?: React.HTMLInputTypeAttribute;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { className = '', type = 'text', label, hint, hintClassName, hintId, hintHidden, id, ...props },
    ref
  ) => {
    return (
      <>
        {label ? <label htmlFor={id}>{label}</label> : null}
        <input id={id} ref={ref} className={className || undefined} {...props} type={type} />
        {hint ? (
          <small
            id={hintId}
            hidden={hintHidden}
            className={`hint${hintClassName ? ' ' + hintClassName : ''}`}
          >
            {hint}
          </small>
        ) : null}
      </>
    );
  }
);

Input.displayName = 'Input';

export default Input;
